import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/static/icons/bundle.svg'


const _hoisted_1 = { class: "bundle-tag" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "bundle-tag__icon" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_3 = { class: "bundle-tag__text" }

import useWebsiteTexts from '@/composables/useWebsiteTexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'BundleTag',
  setup(__props) {

const { websiteText } = useWebsiteTexts();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(websiteText)('product__tag_bundle').value), 1)
  ]))
}
}

})